module.exports = __webpack_public_path__ + "static/img/6.18c25120.jpg";